export default [
	{
		settings: true,
		text: "ID",
		value: "id",
		func: true,
		valueFilter: "filter_id",
		model: { value: 'list' },
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Date",
		value: "date_create",
		valueFilter: 'filter_date',
		model: { value: 'date' },
		func: true,
		sortable: true,
		dense: true,
		nowrap: true
	},

	{
		settings: true,
		text: "Amount",
		value: "amount",
		func: true,
		valueFilter: 'filter_amount',
		model: { value: 'number' },
		sortable: true,
		toLeft: true,
		modValue: 'isDeCode',
		dollar: true,
		fullTotal: true
	},

	{
		settings: true,
		text: "Status",
		value: "status",
		func: false,
		valueFilter: 'filter_status',
		model: { value: 'list' },
		sortable: false,
		toLeft: true,
		modValue: 'paidComplete'
	},

	// {
	// 	settings: true,
	// 	text: "Type",
	// 	value: "type_number",
	// 	func: true,
	// 	valueFilter: 'filter_type',
	// 	model: { value: 'list' },
	// 	sortable: true,
	// },

	{
		settings: true,
		text: "Name",
		value: "name",
		func: true,
		valueFilter: 'filter_name',
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "Customer",
		value: "customer",
		func: true,
		valueFilter: 'filter_customer',
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "Assigned",
		value: "paid",
		func: true,
		valueFilter: 'filter_assigned',
		model: { value: 'list' },
		sortable: true,
		isStatus: true,
		align: 'center',
	},
	{
		settings: true,
		text: "Invoice number",
		value: "invoice_id",
		func: true,
		valueFilter: 'filter_invoice_id',
		model: { value: 'list' },
		sortable: true,
		iconValue: { icon: 'number', value: 'invoice_id', iconWidth: '12', iconHeight: '12', class: 'payment-id' }
	},
	{
		settings: true,
		text: "Customer payments id",
		value: "customer_payments_id",
		func: true,
		valueFilter: 'filter_customer_payments_id',
		model: { value: 'list' },
		sortable: true,
		iconValue: { icon: 'number', value: 'customer_payments_id', iconWidth: '12', iconHeight: '12', class: 'payment-id' }
	},
	{
		settings: true,
		text: "Description",
		value: "original_description",
		func: true,
		valueFilter: 'filter_original_description',
		model: { value: 'note' },
		sortable: true,
	},

	{
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'paid',
				text: 'Pay invoice',
				icon: { value: 'paid', w: 22, h: 22 },
			},
			{
				perm: true,
				value: 'edit1',
				text: 'Edit',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			// {
			// 	perm: {
			// 		or: [ 11 ]
			// 	},
			// 	value: 'delete',
			// 	text: 'Delete driver',
			// 	icon: { value: 'deleteItem', w: 18, h: 18 },
			// }
		]
	},
];
